import { useTranslation } from 'react-i18next';
import { TextSemiBold } from 'UiKit/typography';
import ScheduleRulesetProvider, { useScheduleRulesetState } from 'View/schedule-ruleset/state';
import FormUpsert from 'View/schedule-ruleset/section/form-upsert';

import styles from './styles.module.css';

const ButtonChangeRuleset = ({ ruleset }) => {
  const { t } = useTranslation('schedule-generate');
  const { updateState } = useScheduleRulesetState();

  return (
    <>
      <TextSemiBold
        className={styles['ruleset__text--button']}
        onClick={() => {
          updateState({
            isOpenFormUpsert: true,
            selectedRuleset: ruleset,
          });
        }}
      >
        {t('dataIncorrectChangeInRuleset')}
      </TextSemiBold>
      <FormUpsert />
    </>
  );
};

const ButtonChangeContainer = ({ ruleset }) => <ScheduleRulesetProvider children={<ButtonChangeRuleset ruleset={ruleset} />} />;

export default ButtonChangeContainer;
